import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription, of, BehaviorSubject } from "rxjs";
import { FlowHistoryItem, NotesData } from "../../models/note.model";
import { NoteService } from "../../services/note.service";
import { DetailedFlowHistory, EntryType, HistoryType } from "../../models/flow.dto";
import { WorkOrderWithAssignments, WorkOrderStatus } from "../../models/work-order.model";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { OrganizationService } from "../../services/organization.service";
import { OrganizationStub } from "../../models/organization.model";
import { concatMap, finalize, mergeMap, map } from "rxjs/operators";
import { LoaderService } from "../../services/loader.service";

@Component({
    selector: "history",
    templateUrl: "./history.component.html",
    styleUrls: ["./notes.component.scss"],
    standalone: false
})

export class HistoryComponent extends SidePanelBase implements OnDestroy, OnInit {
    static componentName = "HistoryComponent";

    public _notesSubscription: Subscription;
    flowHistory = [];
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    statusEnum = EntryType; 

    constructor(
        public notesService: NoteService,
        public organizationService: OrganizationService,
    ) {
        super();
    }

    ngOnInit() {
        //this.loader.toggleLoader(true);
        this._notesSubscription = this.notesService.note$.pipe(mergeMap((newNote: NotesData) => {
            let orgIds = newNote.history.map(a => a.userInfo.organizationId);
            //Do a first pass to at least build the entries and set the orgId where the contact is of the same org as entries
            let tempOrgStubs = [
                {
                    id: (newNote.history && newNote.history.length > 0 && newNote.history[0].organization) ? newNote.history[0].organization.id : "",
                    name: (newNote.history && newNote.history.length > 0 && newNote.history[0].organization) ? newNote.history[0].organization.name : ""
                } as OrganizationStub
            ];
            let historyItems = this.buildHistoricEntries(newNote.currentWorkItem, newNote.history, tempOrgStubs, newNote.workItems);
            orgIds = orgIds.filter(a => a != tempOrgStubs[0].id);
            if (orgIds.length > 0) {
                return this.organizationService.getOrganizationStubs(orgIds).pipe(
                    map((orgStubs) => {
                        //Add the One for flow org back in
                        orgStubs.push(tempOrgStubs[0]);
                        return this.buildHistoricEntries(newNote.currentWorkItem, newNote.history, orgStubs, newNote.workItems);
                    }))
            }
            else
                return of(historyItems);
        })).subscribe((history) => {
            this.flowHistory = history;
            this.loading.next(false);
        },
            (error) => {
                console.error(error);
            });
    }

    ngOnDestroy(): void {
        this._notesSubscription.unsubscribe();
    }

    public buildHistoricEntries(currentWorkOrderId: string, history: DetailedFlowHistory[], orgStubs: OrganizationStub[], workOrders: WorkOrderWithAssignments[]): Array<any> {
        const historicEntries = new Array<any>();
        var statusTypes = Object.keys(EntryType);
        for (let h = 0; h < history.length; h++) {
            let temp = history[h];
            let userOrg = orgStubs.filter(a => a.id == temp.userInfo.organizationId);
            let orgName = "Fetching Org Name...";
            if (temp.userInfo.displayName === 'RICS') orgName = 'RICS';
            else if (userOrg.length > 0) orgName = userOrg[0].name;
            

            let workOrder = temp.workItem && temp.workItem.id ? workOrders.find(wi => wi.id === temp.workItem.id) : null;
            let status = this.statusEnum[statusTypes[temp.entryType]] as any
            let level = 'action'
            if (workOrder != null && status == EntryType.Waiting) {
                level = workOrder.parentTaskId === ""
                    ? "ReviewLevelOne"
                    : "ReviewaLevelTwo"
            }
            if (workOrder != null && workOrder.status == WorkOrderStatus.Completed && status == EntryType.Waiting) continue; //Don't want to show history items of work orders from when they were 'waiting' when the work order is completed
            if (temp.type == HistoryType.WorkOrder && (status == EntryType.Approval || status == EntryType.ReviewApproval)) continue; //Don't want to show history items of work orders when they are approvals as the flow records the approval separately
            let description = (temp.workItem)
                ? temp.workItem.title
                : (status != EntryType.Submission)
                    ? status
                    : "Application Submitted";
            let historyItem: FlowHistoryItem = {
                id: workOrder ? workOrder.id : temp.id,
                userName: temp.userInfo && temp.userInfo.displayName ? temp.userInfo.displayName : "Unregistered User",
                workOrderId: temp.workOrderId,
                organization: orgName,
                fullDate: temp.date,
                eventDescription: description,
                status: status,
                groupName: workOrder && workOrder.assignedGroup && workOrder.assignedGroup.displayName ? workOrder.assignedGroup.displayName : "No Assigned Group",
                assignedTo: workOrder && workOrder.assignee && workOrder.assignee.displayName ? workOrder.assignee.displayName : "No Specific Assigned User",
                level: level,
                type: temp.type
            };
            if (workOrder != null) {
                let exists = historicEntries.findIndex(h => h.type === historyItem.type && h.workOrderId === historyItem.workOrderId && h.eventDescription == historyItem.eventDescription);
                if (exists != -1) {
                    historicEntries.splice(exists, 1);
                }
            }            
            historicEntries.push(historyItem);
        }


        let sortedEntries = historicEntries.sort((a, b) => {
            return new Date(a.fullDate).getTime() - new Date(b.fullDate).getTime();
        });
        return sortedEntries;
    }

    public getBlankHistory(): any {
        return {
            userName: "",
            organization: "",
            groupName: "",
            assignedTo: "",
            eventDescription: "",
            eventDate: "",
            workOrderId: "",
            status: "",
            level: "",
            fullDate: new Date()
        };
    }
}

